<template>
    <div class="container-fluid">
        <div class="container  py-1">
            <div class="text-center">
                <h1 v-if="itemsForm.is_Service === false" class="text-primary text-weight-600 h3">Add New Item</h1>
                <h1 v-if="itemsForm.is_Service === true" class="text-primary text-weight-600 h3">Add New Service</h1>
                <div class="py-3">
                    <p>To change from adding a Service or Item </p>
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="customSwitch1" v-model="itemsForm.is_Service" checked>
                        <label v-if="itemsForm.is_Service === true" class="custom-control-label" for="customSwitch1">Add an item instead</label>
                        <label v-if="itemsForm.is_Service === false" class="custom-control-label text-danger" for="customSwitch1">Add a service instead</label>
                    </div>
                </div>
            </div>
            <form v-if="itemsForm.is_Service === false" class="mb-5 form-signin-product" @submit.prevent="submitProduct">
                <!-- <div class="container">
                                        <div class="row align-items-center h-100">
                                            <div class="col-12 mx-auto">
                                                <div class="jumbotron">
                                                    <fileuploader></fileuploader>
                                                </div>
                                            </div>
                                        </div>
                                    </div> -->
                <div class="text-center">
                    <h5 class="text-dark text-left text-weight-400 pb-2">Product Details</h5>
                </div>
                <div class="form-group">
                    <label>Item Name</label><span class="text-danger">*</span>
                    <input type="text" class="form-control border" placeholder="Item Title" v-model="itemsForm.title" required/>
                </div>
                <div class="form-group">
                    <label>Buying Price</label><span class="text-danger">*</span>
                    <input type="text" class="form-control border" placeholder="Price per unit" v-model="itemsForm.wholesale_ppu" required/>
                    <small class="pl-3 text-dark">Buying Price</small>
                </div>
                <div class="form-group">
                    <label>Selling Price</label><span class="text-danger">*</span>
                    <input type="text" class="form-control border" placeholder="Price per unit" v-model="itemsForm.ppu" required/>
                    <small class="pl-3 text-dark">Retail Price per unit</small>
                </div>
                <div class="border rounded p-3 mb-3">
                    <p class="mb-2 text-muted"><small><strong>Accounting Behaviour</strong></small></p>
                    <div class="d-flex justify-content-between align-items-center py-2 border-bottom">
                        <div>
                            <label class="mb-0">Contributes to Profit</label>
                            <small class="d-block text-muted">Turn off for pass-through items (e.g. packaging, levy)</small>
                        </div>
                        <b-form-checkbox v-model="itemsForm.affects_profit" switch size="lg" />
                    </div>
                    <div class="d-flex justify-content-between align-items-center py-2">
                        <div>
                            <label class="mb-0">Affects Inventory</label>
                            <small class="d-block text-muted">Turn off if this item does not consume stock</small>
                        </div>
                        <b-form-checkbox v-model="itemsForm.affects_inventory" switch size="lg" />
                    </div>
                </div>
                 <div class="form-group" v-if="userDetails.company.companysettings.has_wholesale">
                        <label>Wholesale selling price</label>
                        <input class="border form-control" placeholder="Wholesale selling price"
                            v-model="itemsForm.wholesale_sp" />
                    </div>
                <div class="form-group">
                    <label>Measuring Unit</label><span class="text-danger">*</span>
                    <input type="text" class="form-control border" placeholder="Measuring Unit" v-model="itemsForm.measunit" required/>
                    <small class="pl-3 text-dark">Measuring Unit (Kgs,Pieces,Litres etc)</small>
                </div>
                <div class="form-group">
                    <label>SKU (Store keeping unit)</label>
                    <input type="text" class="form-control border" placeholder="sku" v-model="itemsForm.sku" />
                    <small class="pl-3 text-dark">Store keeping unit</small>
                </div>
                <div class="form-group">
                    <label>Item Count</label><span class="text-danger">*</span>
                    <input type="text" class="form-control border" placeholder="Quantity" v-model="itemsForm.qty" required/>
                    <small class="pl-3 text-dark">eg. 10</small>
                </div>
                <div class="form-group">
                    <label>Item Category</label><span class="text-danger">*</span>
                    <p class="text-danger" v-if="itemsForm.categorySelectError !==''">{{ itemsForm.categorySelectError }}</p>
                    <p class="text-danger" v-if="categoryOptions.length === 1">Seems you don't have any category - <a href="#" @click="createProductCatModal">Create One</a></p>
                    <b-form-select v-model="itemsForm.selectedCategory" :options="categoryOptions">
                    </b-form-select>
                    <p class="text-dark" v-if="categoryOptions.length > 1">Can't see a category - <a href="#" @click="createProductCatModal">Add One</a></p>
                </div>
                <!-- <div class="form-group">
<div class="form-check">
                <input class="form-check-input" type="checkbox" value="" id="defaultCheck1" v-model="itemsForm.can_be_sold">
                <label class="form-check-label" for="defaultCheck1">
                Item can be sold
                </label>
                </div>
                <small>You can have items just to track but not to be sold, e.g ingredeints, or items for use internally</small>
                </div> -->

                <button class="btn btn-block btn-primary" type="submit">Create Item</button>
            </form>
            <form v-if="itemsForm.is_Service === true" class="mb-5 form-signin-product" @submit.prevent="submitProduct">
                <!-- <div class="container">
                                        <div class="row align-items-center h-100">
                                            <div class="col-12 mx-auto">
                                                <div class="jumbotron">
                                                    <fileuploader></fileuploader>
                                                </div>
                                            </div>
                                        </div>
                                    </div> -->
                <div class="text-center">
                    <h5 class="text-dark text-left text-weight-400 pb-2">Service Details</h5>
                </div>
                <div class="form-group">
                    <label>Service title</label><span class="text-danger">*</span>
                    <input type="text" class="form-control border" placeholder="Service Title" v-model="itemsForm.title" required/>
                </div>
                <div class="form-group">
                    <label>Charges</label><span class="text-danger">*</span>
                    <input type="text" class="form-control border" placeholder="Rate " v-model="itemsForm.ppu" required/>
                    <small class="pl-3 text-dark">How much do you charge for the service</small>
                </div>
                <div class="border rounded p-3 mb-3">
                    <p class="mb-2 text-muted"><small><strong>Accounting Behaviour</strong></small></p>
                    <div class="d-flex justify-content-between align-items-center py-2">
                        <div>
                            <label class="mb-0">Contributes to Profit</label>
                            <small class="d-block text-muted">Turn off for pass-through fees (e.g. Delivery, Packaging)</small>
                        </div>
                        <b-form-checkbox v-model="itemsForm.affects_profit" switch size="lg" />
                    </div>
                </div>
                <div class="form-group">
                    <label>Service Category</label><span class="text-danger">*</span>
                    <p class="text-danger" v-if="itemsForm.categorySelectError !==''">{{ itemsForm.categorySelectError }}</p>
                    <p class="text-danger" v-if="categoryOptions.length === 1">Seems you don't have any category - <a href="#" @click="createProductCatModal">Create One</a></p>
                    <b-form-select v-model="itemsForm.selectedCategory" :options="categoryOptions">
                    </b-form-select>
                    <p class="text-dark" v-if="categoryOptions.length > 1">Can't see a category - <a href="#" @click="createProductCatModal">Add One</a></p>
                </div>
                <button class="btn btn-block btn-primary" type="submit">Add Service</button>
            </form>
        </div>
        <b-modal ref="createProductCatModal" id="bv-modal-edit" hide-footer>
            <h6>Create New Product Category</h6>
            <form @submit.prevent="createNewCategory">
                <div class="form-group">
                    <input class="form-control border" placeholder="Product Category" type="text" v-model="newproductcat" />
                </div>
                <div class="form-group">
                    <button type="submit" class="btn btn-primary">Submit</button>
                </div>
            </form>
        </b-modal>
        <b-modal ref="addProdModalSuccess" hide-header-close no-close-on-esc no-close-on-backdrop id="bv-modal-edit" hide-footer>
            <div class="text-center">
                <p class="text-success" style="font-size: 70px; font-weight: 300;"><i class="bi bi-check-circle"></i></p>
                <h6 >Your Item has been created successfully</h6>
                <div class="btn-group w-100 py-5">
                    <a href="/inventory?import-modal=1" class="btn btn-sm btn-outline-primary rounded">Import Instead</a>
                    <a href="/addprod" class="btn btn-sm btn-secondary mx-1 rounded">Add a new Item</a>
                    <a href="/inventory" class="btn btn-sm btn-outline-primary rounded">Check Inventory</a>
                    <a></a>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import productCacheService from '../IndexDB/productCacheService'
    import { mapGetters } from "vuex";

    export default {
        data() {
            return {
                itemsForm: {
                    selectedCategory: null,
                    title: '',
                    qty: '',
                    measunit: '',
                    wholesale_sp: '',
                    wholesale_ppu: '',
                    ppu: '',
                    categorySelectError: '',
                    sku: '',
                    is_Service: false,
                    affects_profit: true,
                    affects_inventory: true,
                    can_be_sold: true,
                },
                categoryOptions: [{
                    value: null,
                    text: 'Select Category'
                }],
                newproductcat: ''
            }
        },
        mounted() {
            this.getCategories()
        },
                computed: {

            ...mapGetters(['userDetails']),
                },
        methods: {
            async submitProduct() {
                if (this.itemsForm.selectedCategory !== null) {
                   await axios.post('/api/addprod', { ...this.itemsForm
                    }).then(results => {
                        productCacheService.hotReloadLocalDB().catch(e => console.warn('POS cache refresh failed:', e.message))
                        this.$refs['addProdModalSuccess'].show();

                    }).catch(error => {
                        this.$toasts.push({
                            type: 'error',
                            message: error?.response?.data?.message || 'Could not create item. Please try again.',
                        });
                    })
                } else {
                    this.itemsForm.categorySelectError = 'You need to select a category'
                }
            },
            createProductCatModal() {
                this.$refs['createProductCatModal'].show();
            },
            getCategories() {
                axios.get('/api/items-category').then(results => {
                    $.each(results.data, (key, value) => {
                        const itemCat = {
                            value: value.id,
                            text: value.name
                        }
                        this.categoryOptions.push(itemCat)
                    })
                }).catch(errors => {
                    console.log(errors)
                })
            },
            createNewCategory() {
                if (this.newproductcat !== '') {
                    axios.post('/api/manage-category/create/product', {
                        productcat: this.newproductcat
                    }).then(results => {

                        this.itemsForm.selectedCategory = results.data.categoryId
                        this.$refs['createProductCatModal'].hide();
                        this.getCategories()
                    }).catch(error => {
                        axios.post('/api/report-error', {
                            source: 'creating new category' + this.newproductcat,
                            script: "products.vue",
                            errormessage: error.response.data.message,
                            errorstatus: error.response.data.status
                        }).then(results => {
                            this.$toasts.push({
                                type: 'There was an error. Please retry',
                                message: 'error',
                            });
                        });
                    });
                }
            },
        }
    }
</script>

<style>
    .form-signin-product {
        width: 100%;
        max-width: 450px;
        padding: 15px;
        margin: auto;
        margin-bottom: auto;
    }
</style>
